import request from '@/utils/request';

//门店
export function getStores(values) {
  return request('/store/queryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}

//公司
export function getCompany(param) {
  return request('/company/queryList', {
    method: 'GET',
    params: param,
  });
}

//产品
export function getProducts(values) {
  return request('/product/queryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//产品series
export function getProductsSeries(values) {
  return request('/product/queryDimPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
// 系列产品
export function getNewProductsSeries(values) {
  return request('/product/queryCategoryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
// 款号商品
export function getNewProductsStyles(values) {
  return request('/product/queryCategoryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
// 货号商品
export function getNewProductsGoods(values) {
  return request('/product/queryCategoryPage', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
//优惠券模板
export function getQueryTemplateList(param) {
  return request('/stockCoupon/queryTemplateList', {
    method: 'GET',
    params: param,
  });
}

//新增满减优惠券
export function addCoupon(values) {
  return request('/coupon/add', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}

//编辑初始化
export function couponInitData(values) {
  return request('/coupon/queryDetail', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}

//编辑提交
export function updateCoupon(values) {
  return request('/coupon/update', {
    method: 'POST',
    data: {
      ...values,
    },
  });
}
